import { Settings } from '@/features/settings/components';

export default function SettingsPage() {
  return <Settings />;
}
